import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=35d98d19&scoped=true&"
import script from "./MessageCenter.vue?vue&type=script&lang=js&"
export * from "./MessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=35d98d19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d98d19",
  null
  
)

export default component.exports